module.exports = __webpack_public_path__ + "static/mixta-regular-5a0e51092c4e744bde91d6e9ed83add6.otf";